import React, {PureComponent} from "react"

import StatusNotification from "@irati/ui/src/StatusNotification"
import {RouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import workosService from "@irati/workos/services/workos"
import auth from "@irati/auth"

import {SETTINGS_LOGIN_INTEGRATION} from "../../routes/routeConfig"

interface Props {}

interface State {
  isEnabled: boolean
}

class PeopleDirectoryHeader extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isEnabled: false
    }
  }

  componentDidMount() {
    this.fetchWorkOSOrganisation()
  }

  fetchWorkOSOrganisation = () => {
    const businessId = auth.business().uuid
    if (businessId) {
      workosService.getOrganisation(businessId).then((workOSOrganisation) => {
        const directorySyncId = workOSOrganisation.directoryId
        this.setState({isEnabled: directorySyncId})
      })
    }
  }

  render() {
    const {isEnabled} = this.state

    return (
      <StatusNotification
        type="PairLabels"
        labelState={isEnabled}
        labelText={{
          enabled: "admin.containers.manageUsers.peopleDirectoryHeader.enabled",
          disabled: "admin.containers.manageUsers.peopleDirectoryHeader.disabled"}}
        notificationText={{
          enabled: "admin.containers.manageUsers.peopleDirectoryHeader.statusEnabled",
          disabled: "admin.containers.manageUsers.peopleDirectoryHeader.statusDisabled"}}>
        {!isEnabled &&
          <RouterLink to={SETTINGS_LOGIN_INTEGRATION} cta marginLeft="7px">
            <FormattedMessage id="admin.containers.manageUsers.peopleDirectoryHeader.statusDisabledLink" />
          </RouterLink>}
      </StatusNotification>
    )
  }
}
export default PeopleDirectoryHeader
